import ChairOutlined from '../../src/legacy/ChairOutlined';
export default ChairOutlined;
